import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { TrackableEntity } from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';

export class BtDoDetail extends TrackableEntity {
    id: number = 0;
    doId: number = 0;
    orderId: number = 0;
    seqNo: number = 0;
    destPort: string = '';
    orderNo: string = '';
    pkgs: number = 0;
    punit: string = '';
    kgs: number = 0;
    lbs: number = 0;
    cft: number = 0;
    cbm: number = 0;
    puLoc: number = 0;
    puLocName : string = '';
    deliverTo: number = 0;
    deliverToName: string = '';
    refNo: string = '';
    trailer: string = '';
    origin: number = 0;
    originName: string = '';

    constructor(init?:Partial<BtDoDetail>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }
    
    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return  BtDoDetail.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_ID', table: 'T_BTDODETAIL' }),
        'doId': new DBMappingInfo({ field: 'F_DoID', table: 'T_BTDODETAIL' }),
        'orderId': new DBMappingInfo({ field: 'F_OrderID', table: 'T_BTDODETAIL' }),
        'seqNo': new DBMappingInfo({ field: 'F_SeqNo', table: 'T_BTDODETAIL' }),
    }
}